<template>
  <div class="interstitial interstitial--last">
    <b-container class="text-center">
      <b-row align-h="center">
        <b-col md="8" sm="12">
          <h2 class="mb-0">Crunching all the numbers.</h2>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'LastInterstitial',
  props: {
    user: Object
  },
  mounted: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    this.delay = window.setTimeout(() => this.$emit('completed'), 3000);
    container.classList.add('container-hidden');
  },
  destroyed: function() {
    var container = document.getElementById('discover-kettle-college-tool');
    window.clearTimeout(this.delay);
    container.classList.remove('container-hidden');
  },
}
</script>

<style scoped>
</style>
